import { UserSettingsModels } from '@share-models';

export const uiUserSettingsDateFormatMap: Record<
  UserSettingsModels.UiUserSettingsDateFormat,
  string
> = {
  [UserSettingsModels.UiUserSettingsDateFormat.MMddyy]: 'MM/dd/yy',
  [UserSettingsModels.UiUserSettingsDateFormat.ddMMyy]: 'dd/MM/yy',
};

export const hoursFormatMap: Record<UserSettingsModels.HoursFormat, string> = {
  [UserSettingsModels.HoursFormat.hours12]: '12 hours',
  [UserSettingsModels.HoursFormat.hours24]: '24 hours',
};

export const DEFAULT_ACCOUNT_DETAILS_VISIBILITY: UserSettingsModels.AccountDetailsVisibility = {
  [UserSettingsModels.AccountDetailsSetting.FULL_NAME]: true,
  [UserSettingsModels.AccountDetailsSetting.EMAIL]: true,
  [UserSettingsModels.AccountDetailsSetting.PHONE]: true,
  [UserSettingsModels.AccountDetailsSetting.DATE_TIME]: true,
  [UserSettingsModels.AccountDetailsSetting.LANGUAGE]: true,
  [UserSettingsModels.AccountDetailsSetting.THEME]: true,
  [UserSettingsModels.AccountDetailsSetting.WEEKLY_EMAILS]: true,
  [UserSettingsModels.AccountDetailsSetting.DEVICE_PAGE_VIEW]: true,
  [UserSettingsModels.AccountDetailsSetting.DEVICE_EMAILS]: true,
  [UserSettingsModels.AccountDetailsSetting.GLOBAL_SEARCH]: true,
  [UserSettingsModels.AccountDetailsSetting.AUTO_LOGOUT]: true,
};
